import { useEffect } from "react";
import { S1MetadataCard } from "./card";
import { S1MetadataNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S1MetadataTable } from "./table";

export default function S1Metadata() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Métadonnées S1");
  }, []);

  return (
    <Routes>
      <Route index element={<S1MetadataTable />} />
      <Route path="/new" element={<S1MetadataNew />} />
      <Route path=":id" element={<S1MetadataCard />} />
    </Routes>
  );
}
